import React from "react";

const CPDCard = ({ id, onChange, item, onDelete }) => {
  return (
    <div className="w-full flex mb-4 items-center justify-between">
      <div className="w-[60%]">
        <label
          htmlFor={id}
          className="block text-[#757575] text-sm font-bold mb-1"
        >
          {item.eventCPDCreditName}
        </label>
        <input
          id={id}
          type="text"
          name={item?.eventCPDCreditName}
          value={item?.eventCPDCreditValue}
          onChange={(e) =>
            onChange({ ...item, eventCPDCreditValue: e.target.value })
          }
          className="w-full border border-gray-300 rounded text-sm "
          placeholder="Enter CPD points"
          //min="0"
        />
      </div>

      <div className="mt-2 w-[30%] flex wrap flex-col">
        <label
          htmlFor={id + "checkbox"}
          className="inline-flex items-center text-sm text-[#757575]"
        >
          <input
            id={id + "checkbox"}
            name={item?.eventCPDCreditName + "checkbox"}
            type="checkbox"
            checked={item?.isVisible || false}
            onChange={(e) => onChange({ ...item, isVisible: e.target.checked })}
            className="mr-2"
          />
          Visible
        </label>
        <button
          className="bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-2 px-4 border border-red-500 hover:border-transparent rounded text-sm "
          onClick={() => onDelete()}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default CPDCard;
